export default __webpack_public_path__ + "static/media/question-mark.e1d5e045.svg";